import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { map, catchError } from 'rxjs/operators';
import { Langue } from '@app/models/langue';

@Injectable({ providedIn: 'root' })
export class LangueService {
  constructor(private httpClient: HttpClient) {
  }

  getLangues() {
    return this.httpClient
      .get<any>(`${environment.apiEndPoint}languages/read`)
      .pipe(
        map(res => res ? res.document.records as Langue[] : []),
        catchError(this.handleError)
      );
  }

  getLanguesById(id) {
    return this.httpClient
      .post<any>(`${environment.apiEndPoint}language/read_one`, JSON.stringify({ id: `${id}` }))
      .pipe(
        map(res => res.document as Langue),
        catchError(this.handleError)
      );
  }

  private handleError(error: any): Promise<any> {
    let retour = error?.error?.message || error?.message || error;
    if(error?.error?.data) retour += '<br />'+error?.error?.data;
    return Promise.reject(retour);
  }
}